export default function(username: string): boolean {
	return !/[a-zA-Z0-9]{8,16}$/i.test(username);
}
